import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-menu.mjs";
import { render } from "lit-html";

import { Drawer } from "flowbite";
import type { DrawerOptions, DrawerInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

export class HbMenu extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private drawer: DrawerInterface;

    private menu: HTMLElement;
    private passkey: HTMLLIElement | null; // login
    //private close: HTMLElement;

    private passkeys: HTMLLIElement;
    private keyhold: HTMLLIElement;
    private safes: HTMLLIElement;

    private passkeysCount = 0;

    constructor() {
        super();
        render(template(null), this);

        this.menu = this.querySelector("#hb-menu")!;
        this.passkey = this.querySelector("#hb-menu-passkey");
        //this.close = this.querySelector("button[data-drawer-hide]")!;

        this.passkeys = this.querySelector("#hb-menu-passkeys")!;
        this.keyhold = this.querySelector("#hb-menu-keyhold")!;
        this.safes = this.querySelector("#hb-menu-safes")!;

        const options: DrawerOptions = {
            placement: "left",
            backdrop: true,
            bodyScrolling: false,
            edge: false,
            edgeOffset: "",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-30",
            onHide: () => {
                //window.location.hash = "#";
                //this.close.click(); // bc hide doesn't disable backdrop
            },
            onShow: () => {
                //console.log("drawer is shown");
            },
            onToggle: () => {
                //console.log("drawer has been toggled");
            }
        };

        const instanceOptions: InstanceOptions = {
            id: "hb-menu",
            override: true
        };

        this.drawer = new Drawer(this.menu, options, instanceOptions);
    }

    connectedCallback() {
        if (!this.heartbank.isPasskeySupported()) {
            if (this.passkey) {
                const a = this.passkey.firstElementChild as HTMLAnchorElement;
                a.removeAttribute("href");
                this.passkey.classList.add("opacity-50");
                this.passkey.onclick = () =>
                    alert("Sorry, passkeys are not supported on this device.");
            }

            const a = this.passkeys.firstElementChild as HTMLAnchorElement;
            a.removeAttribute("href");
            this.passkeys.classList.add("opacity-50");
            this.passkeys.onclick = () =>
                alert("Sorry, passkeys are not supported on this device.");
        }

        this.heartbank.addAuthStateListener(async (user) => {
            render(template(user), this);

            if (user) {
                this.passkeysCount = await this.heartbank.passKeysCount();
                this.render();

                const notifications = this.querySelector(
                    "#hb-menu-notifications"
                ) as HTMLAnchorElement;
                notifications.addEventListener("click", async () => {
                    if (
                        confirm(
                            "Would you like to receive push notifications on this device only?"
                        )
                    ) {
                        await this.heartbank.saveTokenToFirestore();
                        alert(
                            "You have successfully registered this device for Push Notifications!\n\nNOTE: You need to add this app to your Home Screen in order to instantly receive an alert whenever someone nearby sends you a B-Token of Appreciation!"
                        );
                    }
                });
            }
        });
    }

    async render() {
        if (this.passkeysCount === 0) {
            const a1 = this.keyhold.firstElementChild as HTMLAnchorElement;
            a1.removeAttribute("href");
            this.keyhold.classList.add("opacity-50");
            this.keyhold.onclick = () => {
                if (
                    confirm(
                        "A passkey is required to create Bankkeys.\n\nWould you like to create one now?"
                    )
                ) {
                    localStorage.setItem(
                        "redirect-lockbox",
                        window.location.hash
                    );
                    window.location.hash = "#/lockbox";
                }
            };

            const a2 = this.safes.firstElementChild as HTMLAnchorElement;
            a2.removeAttribute("href");
            this.safes.classList.add("opacity-50");
            this.safes.onclick = () => {
                if (
                    confirm(
                        "A passkey is required to create Safes.\n\nWould you like to create one now?"
                    )
                ) {
                    localStorage.setItem(
                        "redirect-lockbox",
                        window.location.hash
                    );
                    window.location.hash = "#/lockbox";
                }
            };
        } else {
            const a1 = this.keyhold.firstElementChild as HTMLAnchorElement;
            a1.setAttribute("href", "#/keyhold");
            this.keyhold.classList.remove("opacity-50");
            this.keyhold.onclick = null;

            const a2 = this.safes.firstElementChild as HTMLAnchorElement;
            a2.setAttribute("href", "#/safes");
            this.safes.classList.remove("opacity-50");
            this.safes.onclick = null;
        }
    }

    show() {
        this.drawer.show();
    }

    hide() {
        this.drawer.hide();
    }
}
